import { useRouter } from 'next/router';

import JointCertificateInstallView from '@/components/tax-refund/common/view/JointCertificateInstallView';
import { DECISION_PATHS } from '@/lib/constants/paths';

const DecisionJointCertificateInstallContent = () => {
  const router = useRouter();

  const moveJointCertificateSelectPage = () => {
    router.replace(DECISION_PATHS.공동인증서선택);
  };

  return (
    <JointCertificateInstallView
      viewController={{
        moveJointCertificateSelectPage
      }}
    />
  );
};

export default DecisionJointCertificateInstallContent;
